module.exports = __webpack_public_path__ + "img/gebrateneshuehnerfleischmithintergrund.1541fc75.jpg";